<template>
  <Badge :color="color">
    <span v-if="$slots.prepend">
      <slot name="prepend" />
    </span>
    <i /> {{ formattedString }}
  </Badge>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { DateTime } from "luxon";
import { useTranslation } from "@/language/translation";
import Badge from "./BadgeComponent.vue";
import { TimeZoneInjectionKey } from "@/functions/timezoneUtil";
import injectAsserted from "@/functions/assert/injectAsserted";

const props = defineProps({
  deadline: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: "#ffffff00",
  },
  dateFormat: {
    type: Object as PropType<Intl.DateTimeFormatOptions>,
    required: false,
    default: () => ({
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    }),
  },
  dateOnly: {
    type: Boolean,
    default: false,
  },
});
const { locale } = useTranslation();
const tz = injectAsserted(TimeZoneInjectionKey);
const formattedString = computed(() => {
  let luxon = DateTime.fromISO(props.deadline).setZone(tz.value);
  return luxon
    .setLocale(locale.value)
    .toLocaleString(props.dateOnly ? DateTime.DATE_SHORT : props.dateFormat);
});
</script>
